const blogGrid = {
  displayField: 'header',
  name: 'Blog Grid',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'articles',
      name: 'Articles',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'article' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: { id: 'blogGrid', version: 4, updatedAt: '2023-08-02T21:17:34.278Z' }
};
export default blogGrid;